<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 750px;">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">匯款單套表列印</p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form" :loading="sending">
            <b-tabs
              v-model="activeTab"
              :animated="false"
              expanded
              @input="onSelectTab"
            >
              <b-tab-item label="自行輸入" :disabled="sending">
                <form-group
                  name="account_name"
                  horizontal
                  :label="'收款人' + $t('attributes.account_name')"
                  label-position="on-border"
                >
                  <b-input v-model="form.account_name" type="text" expanded />
                </form-group>
                <form-group
                  name="bank"
                  horizontal
                  label="收款行"
                  label-position="on-border"
                >
                  <b-select
                    v-model="selectedBank"
                    name="banks"
                    placeholder="請選擇收款行"
                    expanded
                    @input="onBankSelected"
                  >
                    <option value="">請選擇銀行</option>
                    <option
                      v-for="option in banks"
                      :value="option"
                      :key="option.bank_number"
                    >
                      [{{ option.bank_number }}]{{ option.bank_name }}
                    </option>
                  </b-select>
                </form-group>
                <form-group
                  name="branch_name"
                  horizontal
                  label="分行支庫局"
                  label-position="on-border"
                >
                  <b-input v-model="form.branch_name" type="text" expanded />
                </form-group>
                <form-group
                  name="account_number"
                  horizontal
                  :label="$t('attributes.account_number')"
                  label-position="on-border"
                >
                  <b-input
                    type="number"
                    v-model="form.account_number"
                    expanded
                  />
                </form-group>
              </b-tab-item>
              <b-tab-item label="選擇廠商" :disabled="sending">
                <form-group
                  name="company"
                  horizontal
                  label="廠商"
                  label-position="on-border"
                >
                  <b-autocomplete
                    v-model="businessEntitySearch"
                    name="search_user"
                    field="id"
                    keep-first
                    :data="businessEntityList"
                    :loading="loadBusinessEntity"
                    :custom-formatter="b => `${b.business_number} ${b.name}`"
                    placeholder="請輸入公司名或統編"
                    :open-on-focus="false"
                    @typing="loadBusinessEntityList"
                    @select="onSelectedBusinessEntity"
                  >
                    <template #default="props">
                      <p>
                        <span>{{ props.option.business_number }}</span> -
                        <span>{{ props.option.name }}</span>
                      </p>
                    </template>
                    <template #empty>
                      {{
                        businessEntityList
                          ? loadBusinessEntity
                            ? $t('attributes.searching')
                            : $t('attributes.not_found')
                          : '請輸入公司名或統編'
                      }}
                    </template>
                  </b-autocomplete>
                </form-group>

                <form-group
                  name="account_name"
                  horizontal
                  label="收款人戶名"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.account_name"
                    type="text"
                    readonly
                    placeholder="選擇廠商後自動填入"
                    expanded
                  />
                </form-group>
                <form-group
                  name="bank"
                  horizontal
                  label="銀行"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.bank_name"
                    type="text"
                    readonly
                    placeholder="選擇廠商後自動填入"
                    expanded
                  />
                </form-group>
                <form-group
                  name="branch_name"
                  horizontal
                  label="分行支庫局"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.branch_name"
                    type="text"
                    readonly
                    placeholder="選擇廠商後自動填入"
                    expanded
                  />
                </form-group>
                <form-group
                  name="account_number"
                  horizontal
                  label="帳號"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.account_number"
                    type="text"
                    readonly
                    placeholder="選擇廠商後自動填入"
                    expanded
                  />
                </form-group>
              </b-tab-item>
            </b-tabs>
            <form-group
              name="amount"
              horizontal
              label="金額(數字)"
              label-position="on-border"
            >
              <b-input type="number" v-model="form.amount" expanded />
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button :loading="sending" class="is-fullwidth" @click="close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            class="is-fullwidth"
          >
            產生套印表格
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { BUSINESS_ENTITY_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'

export default {
  name: 'RemittanceOrderForm',
  data() {
    return {
      sending: false,
      activeTab: 0,
      form: {
        bank_number: null,
        bank_name: '',
        account_name: '',
        account_number: '',
        branch_name: '',
        amount: null
      },

      banks: [],
      selectedBank: null,

      loadBusinessEntity: false,
      businessEntitySearch: '',
      businessEntityList: [],
      selectedBusinessEntity: null
    }
  },
  validations: {
    form: {
      bank_number: { required },
      bank_name: {},
      branch_name: { required },
      account_number: { required, maxLength: maxLength(50) },
      account_name: { required, maxLength: maxLength(50) },
      amount: { required }
    }
  },
  mounted() {
    this.loadBanks()
  },
  methods: {
    onSelectTab() {
      this.clearRemittanceFields()

      this.businessEntitySearch = ''
      this.businessEntityList = []
      this.selectedBusinessEntity = null

      this.$v.$reset()
    },
    async loadBusinessEntityListAsync() {
      try {
        const api = `${BUSINESS_ENTITY_API}/autocomplete`
        const params = {
          search: this.businessEntitySearch
        }
        this.loadBusinessEntity = true
        const res = await this.axios.get(api, { params })
        this.businessEntityList = res.data.data
      } catch (e) {
        this.businessEntityList = []
        notifyService.fetch_error('businessEntity', e)
      } finally {
        this.loadBusinessEntity = false
      }
    },
    loadBusinessEntityList: debounce(function() {
      if (!this.businessEntitySearch) {
        this.businessEntityList = []
        return
      }

      this.loadBusinessEntityListAsync()
    }, 1000),
    onSelectedBusinessEntity(item) {
      this.selectedBusinessEntity = item || null

      if (!item) {
        this.clearRemittanceFields()
        return
      }

      this.form = this.extractFormValues(item)
    },
    clearRemittanceFields() {
      this.selectedBank = null
      this.form.bank_name = ''
      this.form.bank_number = null
      this.form.branch_name = ''
      this.form.account_number = ''
      this.form.account_name = ''
    },
    async loadBanks() {
      try {
        const api = `${BUSINESS_ENTITY_API}/banks/list`

        this.loading = true
        const res = await this.axios.get(api)
        this.banks = res.data.data

        this.selectedBank = null
        if (this.form.bank_number) {
          this.selectedBank = this.banks.find(
            a => a.bank_number === this.form.bank_number
          )
        }
      } catch (e) {
        this.selectedItem = null
        this.banks = []
        notifyService.fetch_error('bank', e)
      } finally {
        this.loading = false
      }
    },
    extractFormValues(data) {
      this.selectedBank = null
      if (data.bank_number) {
        this.selectedBank =
          this.banks.find(a => a.bank_number === data.bank_number) || null
      }
      return {
        bank_name: data.bank_name || '',
        bank_number: data.bank_number || null,
        branch_name: data.branch_name || '',
        account_number: data.account_number || '',
        account_name: data.account_name || '',
        amount: this.form.amount
      }
    },
    onBankSelected(item) {
      if (!item) {
        this.selectedBank = null
        this.form.bank_name = ''
        this.form.bank_number = null
        return
      }

      this.selectedBank = item
      this.form.bank_name = item.bank_name
      this.form.bank_number = item.bank_number
    },
    async close() {
      this.selectedBank = null
      await this.loadBanks()
      this.form.bank_name = null
      this.form.bank_number = null
      this.form.branch_name = null
      this.form.account_number = null
      this.form.account_name = null
      this.form.amount = null
      this.businessEntitySearch = ''
      await this.loadBusinessEntityList()
      this.$parent.close()
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('send', this.form)
    }
  }
}
</script>
